<template>
	<CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
			<div class="container-fluid">
				<form v-if="TipoVista == 1" id="FormGarantia" role="form" method="post" autocomplete="off" onSubmit="return false">

					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<div class="card" style="border-radius: 15px;">
								<div class="card-body p-4">
									<div class="d-flex">
										<div class="flex-shrink-0">
											<i class="fa fa-file-pdf fa-9x text-warning"></i>
										</div>

										<div class="flex-grow-1 ms-3">
											<h5 class="mb-1">Tolerancias Refractivas</h5>
											<p class="mb-2 pb-1">Documento Relacionado</p>
											<div class="d-flex justify-content-start rounded-3 p-2 mb-2 bg-body-tertiary">
											</div>

											<div class="d-flex pt-1">
												<a :href="RutaFile+'NormaWeb.pdf'" data-mdb-button-init data-mdb-ripple-init class="btn btn-outline-primary me-1 flex-grow-1" target="_blank">Ver Documento</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>

						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<div class="card" style="border-radius: 15px;">
								<div class="card-body p-4">
									<div class="d-flex">
										<div class="flex-shrink-0">
											<i class="fa fa-file-pdf fa-9x text-warning"></i>
										</div>

										<div class="flex-grow-1 ms-3">
											<h5 class="mb-1">Criterios Cosméticos</h5>
											<p class="mb-2 pb-1">Documento Relacionado</p>
											<div class="d-flex justify-content-start rounded-3 p-2 mb-2 bg-body-tertiary">
											</div>

											<div class="d-flex pt-1">
												<a :href="RutaFile+'NormaEsteticos.pdf'" data-mdb-button-init data-mdb-ripple-init class="btn btn-outline-primary me-1 flex-grow-1" target="_blank">Ver Documento</a>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 text-end">
							<button type="button" class="btn btn-primary" @click="ShowForm()">
								Continuar con solicitud <i class="fa fa-arrow-right"></i>
							</button>
						</div>
					</div>
				</form>

				<form v-else id="FormGarantia" role="form" method="post" autocomplete="off" onSubmit="return false">
					
					<div class="form-group row justify-content-end">
						<div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
							<label class="form-label" for="FechaSalida">Fecha de Salida</label>
							<div class="calendar">
								<input type="text" v-model="objGarantia.FechaSalida" class="form-control" readonly>
							</div>
							<CValidation v-if="this.errorvalidacion.FechaSalida" :Mensaje="'*'+errorvalidacion.FechaSalida[0]"/>
						</div>
					</div>

					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<h3>Formato para la solicitud de garantia</h3>
						</div>
					</div>

					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="col-form-label">Estimado cliente le pedimos por faver llenar el siguiente formato para solicitar una garantia, la respuesta dependera del analisis de toda la informacion completa</label>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
							<label class="form-label" for="Fecha">Fecha:</label>
							<div class="calendar">
								<input type="text" v-model="objGarantia.Fecha" class="form-control" readonly>
								<!-- <Datepicker v-model="objGarantia.Fecha" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" placeholder="0000-00-00"></Datepicker> -->
							</div>
							<CValidation v-if="this.errorvalidacion.Fecha" :Mensaje="'*'+errorvalidacion.Fecha[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<label class="form-label" for="NombreCuenta">Nombre de Cuenta:</label>
							<input type="text" v-model="objGarantia.NombreCuenta" class="form-control" id="NombreCuenta" placeholder="Ingresar NombreCuenta" readonly/>
							<CValidation v-if="this.errorvalidacion.NombreCuenta" :Mensaje="'*'+errorvalidacion.NombreCuenta[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
							<label class="form-label" for="Folio">Folio:</label>
							<input type="text" v-model="objGarantia.Folio" class="form-control" id="Folio" placeholder="Ingresar Folio" readonly/>
							<CValidation v-if="this.errorvalidacion.Folio" :Mensaje="'*'+errorvalidacion.Folio[0]"/>
						</div>
					</div>
					
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<label class="form-label" for="Producto">Producto</label>
							<input type="text" v-model="objGarantia.Producto" class="form-control" id="Producto" placeholder="Ingresar Producto" readonly/>
							<CValidation v-if="this.errorvalidacion.Producto" :Mensaje="'*'+errorvalidacion.Producto[0]"/>
						</div>
						
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
							<label class="form-label" for="Material">Material</label>
							<input type="text" v-model="objGarantia.Material" class="form-control" id="Material" placeholder="Ingresar Material" readonly/>
							<CValidation v-if="this.errorvalidacion.Material" :Mensaje="'*'+errorvalidacion.Material[0]"/>
						</div>
					</div>

					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<label class="form-label" for="Proteccion">Proteccion</label>
							<input type="text" v-model="objGarantia.Proteccion" class="form-control" id="Proteccion" placeholder="Ingresar Proteccion" readonly/>
							<CValidation v-if="this.errorvalidacion.Proteccion" :Mensaje="'*'+errorvalidacion.Proteccion[0]"/>
						</div>
						
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6">
							<label class="form-label" for="Recubrimiento">Recubrimiento</label>
							<input type="text" v-model="objGarantia.Recubrimiento" class="form-control" id="Recubrimiento" placeholder="Ingresar Recubrimiento" readonly/>
							<CValidation v-if="this.errorvalidacion.Recubrimiento" :Mensaje="'*'+errorvalidacion.Recubrimiento[0]"/>
						</div>
					</div>

					<div class="row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label>Valores Rx Originales</label>
						</div>
					</div>

					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<table class="table">
								<thead>
									<tr>
										<th></th>
										<th class="text-center">ESF</th>
										<th class="text-center">CIL</th>
										<th class="text-center">EJE</th>
										<th class="text-center">ADD</th>
										<th class="text-center">DNP</th>
										<th class="text-center">ALT</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>RX O.D</td>
										<td>
											<input type="text" v-model="Medidas.RxOD.ESF" class="form-control" readonly>
										</td>
										<td>
											<input type="text" v-model="Medidas.RxOD.CIL" class="form-control" readonly>
										</td>
										<td>
											<input type="text" v-model="Medidas.RxOD.EJE" class="form-control" readonly>
										</td>
										<td>
											<input type="text" v-model="Medidas.RxOD.ADD" class="form-control" readonly>
										</td>
										<td>
											<input type="text" v-model="Medidas.RxOD.DNP" class="form-control" readonly>
										</td>
										<td>
											<input type="text" v-model="Medidas.RxOD.ALT" class="form-control" readonly>
										</td>
									</tr>
									<tr>
										<td>RX O.I</td>
										<td>
											<input type="text" v-model="Medidas.RxOI.ESF" class="form-control" readonly>
										</td>
										<td>
											<input type="text" v-model="Medidas.RxOI.CIL" class="form-control" readonly>
										</td>
										<td>
											<input type="text" v-model="Medidas.RxOI.EJE" class="form-control" readonly>
										</td>
										<td>
											<input type="text" v-model="Medidas.RxOI.ADD" class="form-control" readonly>
										</td>
										<td>
											<input type="text" v-model="Medidas.RxOI.DNP" class="form-control" readonly>
										</td>
										<td>
											<input type="text" v-model="Medidas.RxOI.ALT" class="form-control" readonly>
										</td>
									</tr>
								</tbody>

							</table>
						</div>
					</div>

					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
									<label>¿Reflexión que presenta el problema?</label>
								</div>
							</div>

							<div class="form-group row">
								<div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
									<div class=" form-check-inline form-check form-switch form-sw">
                                        <input type="checkbox" v-model="objGarantia.ErrorEnOD" class="form-check-input" role="switch" true-value="OD" false-value="" id="OD" >
                                        <label class="form-check-label" for="OD">OD</label>
                                    </div>
								</div>

								<div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
									<div class=" form-check-inline form-check form-switch form-sw">
                                        <input type="checkbox" v-model="objGarantia.ErrorEnOI" class="form-check-input" role="switch" true-value="OI" false-value="" id="OI" >
                                        <label class="form-check-label" for="OI">OI</label>
                                    </div>
								</div>
							</div>

						</div>
					</div>

					<!--<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<table class="table">
								<thead>
									<tr>
										<th></th>
										<th class="text-center">ESF</th>
										<th class="text-center">CIL</th>
										<th class="text-center">EJE</th>
										<th class="text-center">ADD</th>
										<th class="text-center">DNP</th>
										<th class="text-center">ALT</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>RX O.D</td>
										<td>
											<input type="text" v-model="Medidas.NewRxOD.ESF" class="form-control">
										</td>
										<td>
											<input type="text" v-model="Medidas.NewRxOD.CIL" class="form-control">
										</td>
										<td>
											<input type="text" v-model="Medidas.NewRxOD.EJE" class="form-control">
										</td>
										<td>
											<input type="text" v-model="Medidas.NewRxOD.ADD" class="form-control">
										</td>
										<td>
											<input type="text" v-model="Medidas.NewRxOD.DNP" class="form-control">
										</td>
										<td>
											<input type="text" v-model="Medidas.NewRxOD.ALT" class="form-control">
										</td>
									</tr>
									<tr>
										<td>RX O.I</td>
										<td>
											<input type="text" v-model="Medidas.NewRxOI.ESF" class="form-control">
										</td>
										<td>
											<input type="text" v-model="Medidas.NewRxOI.CIL" class="form-control">
										</td>
										<td>
											<input type="text" v-model="Medidas.NewRxOI.EJE" class="form-control">
										</td>
										<td>
											<input type="text" v-model="Medidas.NewRxOI.ADD" class="form-control">
										</td>
										<td>
											<input type="text" v-model="Medidas.NewRxOI.DNP" class="form-control">
										</td>
										<td>
											<input type="text" v-model="Medidas.NewRxOI.ALT" class="form-control">
										</td>
									</tr>
								</tbody>

							</table>
						</div>
					</div>-->

					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label>Seleccione segun el motivo de su garantía</label>
						</div>
					</div>
					
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
							<label class="form-label" for="TipoGarantia">Tipo Garantia</label>
							<select v-model="objGarantia.TipoGarantia" @change="LimpiaTipoGarantia()" class="form-select">
								<option value="">Seleccione una opcion</option>
								<option v-for="(item,index) in TiposDeGarantias" :key="index" :value="item.TipoGarantia">{{ item.Texto }}</option>
							</select>
							<CValidation v-if="this.errorvalidacion.TipoGarantia" :Mensaje="'*'+errorvalidacion.TipoGarantia[0]"/>
						</div>

						<div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3" v-show="objGarantia.TipoGarantia == 'Crizal'">
							<label>Rellenar:</label>
							<input type="text" v-model="objGarantia.RespuestaTipoGarantia" class="form-control">
						</div>
						
						<div class="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3">
							<label class="form-label" for="FechaSolicitud">Fecha de solicitud del trabajo</label>
							<div class="calendar">
								<input type="text" v-model="objGarantia.FechaSolicitud" class="form-control" readonly>
								<!-- <Datepicker v-model="objGarantia.FechaSolicitud" :input-class="Setpicker.Style" :format="Setpicker.Formato" :language="Setpicker.Idioma" placeholder="0000-00-00"></Datepicker> -->
							</div>
							<CValidation v-if="this.errorvalidacion.FechaSolicitud" :Mensaje="'*'+errorvalidacion.FechaSolicitud[0]"/>
						</div>
					</div>

					<div class="form-group row" v-show="objGarantia.TipoGarantia == 'Golpe/Rayadura'">
						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<p >Para solicitudes relacionadas con golpes o rayaduras, el reporte deberá realizarrse dentro de un plazo máximo de 3 horas posteriores a la recepción del paquete. <br>
							La lente no debe haber sido manipulada, pintada ni medida en el lensómetro, ya que cualquiera de estas acciones podría provocar rayaduras y anular la posibilidad de gestionar la garantía
							</p>
						</div>

						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<label class="form-label" for="Archivo">Adjuntar Foto</label>
							<div class="input-group">
								<input type="file" class="form-control" id="inputGroupFile04" ref="fileArchivo" accept=".jpg ">
							</div>
							<CValidation v-if="this.errorvalidacion.Archivo" :Mensaje="'*'+errorvalidacion.Archivo[0]"/>
						</div>
					</div>

					<div class="form-group row justify-content-end" v-show="objGarantia.TipoGarantia == 'Golpe-Rayadura'">
						<div class="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
							<template v-if="(objGarantia.ImagenLente != '' && objGarantia.ImagenLente != null) ">
								<img :src="RutaImagen+objGarantia.ImagenLente" width="400px" class="img-fluid">
							</template>
						</div>
					</div>
						
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="MotivoSolicitado">Describa el motivo por el cual esta solicitando la garantia</label>
							<textarea v-model="objGarantia.MotivoSolicitado" class="form-control" id="MotivoSolicitado" placeholder="Ingresar Descripción" rows="3"></textarea>
							<CValidation v-if="this.errorvalidacion.MotivoSolicitado" :Mensaje="'*'+errorvalidacion.MotivoSolicitado[0]"/>
						</div>
					</div>

					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="col-form-label">Conteste segín sea el caso</label>
						</div>
					</div>
						
					<div class="form-group row">
						<div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<label class="form-label" for="MotivoMigracion">Si su paciente realizó una migración de diseño, describa el tipo de progresivo que utiliza.</label>
							<textarea v-model="objGarantia.MotivoMigracion" class="form-control" id="MotivoMigracion" placeholder="Ingresar Descripción" rows="3"></textarea>
							<CValidation v-if="this.errorvalidacion.MotivoMigracion" :Mensaje="'*'+errorvalidacion.MotivoMigracion[0]"/>
						</div>
					</div>
					
											
					<br>
				
				</form>
			</div>
		</template>
	</CLoader>
</template>

<script>

import Calendar from '@/helpers/StaticComboBox.js';
import moment from 'moment';

export default {
    name: 'FormGarantia',
    props: ['poBtnSave'],
    components:{
    },
    data() {
        return {
			ConfigLoad:{
                ShowLoader: true,
                ClassLoad: false,
            },
            objGarantia: {
				IdGarantiaS: 0,
				IdPedido: 0,
				IdArticuloWeb: 0,
				FechaSalida: '',
				Fecha: moment(new Date()).format('YYYY-MM-DD'),
				NombreCuenta: '',
				Folio: '',
				Producto: '',
				Material: '',
				Proteccion: '',
				Recubrimiento: '',
				MedidasRx: '',
				TipoGarantia: '',
				RespuestaTipoGarantia: '',
				FechaSolicitud: '',
				MotivoSolicitado: '',
				MotivoMigracion: '',
				ImagenLente: '',
				IdUserSolicita: 0,
				IdUserAutoriza: 0,
				EstatusGarantia: '',
				EstatusAutorizacion: '',
				ErrorEnOD: '',
				ErrorEnOI: '',
            },
			TiposDeGarantias: [],
			/* [
				{Valor:'Golpe-Rayadura',Texto:'Golpe/Rayadura'},
				{Valor:'Graduacion',Texto:'Graduación'},
				// {Valor:'Bisel',Texto:'Bisel'},
				{Valor:'Antiflex',Texto:'Antiflex'},
				{Valor:'Crizal',Texto:'Crizal'},
				{Valor:'Adaptacion',Texto:'Adaptación'},
				{Valor:'Otros',Texto:'Otros'},
			], */
			GarantiasPorArticulo: [],
			Medidas : {
				RxOD:{
					ESF:'',
					CIL:'',
					EJE:'',
					ADD:'',
					DNP:'',
					ALT:'',
				},
				RxOI: {
					ESF:'',
					CIL:'',
					EJE:'',
					ADD:'',
					DNP:'',
					ALT:'',
				},
				/* NewRxOD:{
					ESF:'',
					CIL:'',
					EJE:'',
					ADD:'',
					DNP:'',
					ALT:'',
				},
				NewRxOI: {
					ESF:'',
					CIL:'',
					EJE:'',
					ADD:'',
					DNP:'',
					ALT:'',
				}, */
			},
			Setpicker:Calendar.calendarSettings,
            errorvalidacion: [],
			Emit: this.poBtnSave.EmitSeccion,
			masks:{ input: 'YYYY-MM-DD'}, // quitar sino lleva fecha
			TipoVista: 1,
			RutaFile: '',
			RutaImagen: '',
        }
    },
    methods :
    {
       	async Guardar()
        {
			let FechaSalida = '';
			let Fecha = '';
			let FechaSolicitud = '';

			if (this.objGarantia.FechaSalida!='') {
				FechaSalida = moment(this.objGarantia.FechaSalida).format('YYYY-MM-DD');
			}
			if (this.objGarantia.Fecha!='') {
				Fecha = moment(this.objGarantia.Fecha).format('YYYY-MM-DD');
			}
			if (this.objGarantia.FechaSolicitud!='') {
				FechaSolicitud = moment(this.objGarantia.FechaSolicitud).format('YYYY-MM-DD');
			}

			let file = this.$refs.fileArchivo.files[0];

			if(this.objGarantia.TipoGarantia == 'Golpe/Rayadura' && file == undefined)
			{
				this.$toast.warning('Debe seleccionar un archivo');
				return false;
			}

			let formData = new FormData();
			formData.set('IdGarantiaS', this.objGarantia.IdGarantiaS);
			formData.set('IdPedido', this.objGarantia.IdPedido);
			formData.set('IdArticuloWeb', this.objGarantia.IdArticuloWeb);
			formData.set('FechaSalida', FechaSalida);
			formData.set('Fecha', Fecha);
			formData.set('NombreCuenta', this.objGarantia.NombreCuenta);
			formData.set('Folio', this.objGarantia.Folio);
			formData.set('Producto', this.objGarantia.Producto);
			formData.set('Material', this.objGarantia.Material);
			formData.set('Proteccion', this.objGarantia.Proteccion);
			formData.set('Recubrimiento', this.objGarantia.Recubrimiento);
			formData.set('MedidasRx', JSON.stringify(this.Medidas));
			formData.set('TipoGarantia', this.objGarantia.TipoGarantia);
			formData.set('RespuestaTipoGarantia', this.objGarantia.RespuestaTipoGarantia);
			formData.set('FechaSolicitud', FechaSolicitud);
			formData.set('MotivoSolicitado', this.objGarantia.MotivoSolicitado);
			formData.set('MotivoMigracion', this.objGarantia.MotivoMigracion);
			formData.set('ImagenLente', this.objGarantia.ImagenLente);
			formData.set('ErrorEnOD', this.objGarantia.ErrorEnOD);
			formData.set('ErrorEnOI', this.objGarantia.ErrorEnOI);
			formData.append('Archivo', file);
			
			this.errorvalidacion = [];
            this.poBtnSave.Toast = 0; 
            this.poBtnSave.DisableBtn = true;
			
			await this.$http.post('garantias', formData,{
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then((res)=>{
				this.EjecutaConExito(res);
			}).catch(err=>{   
				this.EjecutaConError(err);
			});
        },
		EjecutaConExito(res)
        {
            this.poBtnSave.DisableBtn = false;  
            this.poBtnSave.Toast = 1;
            this.bus.$emit('CloseModal_'+this.Emit);
            this.bus.$emit('List_'+this.Emit);
        },
        EjecutaConError(err)
        {
            this.poBtnSave.DisableBtn = false;
            
            if(err.response.data.errors){
                this.errorvalidacion = err.response.data.errors;
                this.poBtnSave.Toast = 2;
            }
            else{
                this.$toast.error(err.response.data.message);
            }
        },
		RecuperaRutasNormas()
        {
            this.$http.get(
                "garantiasrutasnormas"
            ).then((res) => {

				this.RutaFile = res.data.rutaFile;
              
            }).finally(()=>{
            });
        },
		RecuperaPedido()
        {
            this.$http.get(
                "pedidos/"+this.objGarantia.IdPedido
            ).then((res) => {
				let ObjResp = res.data.data;
				// console.log(ObjResp)

				this.objGarantia.IdArticuloWeb = ObjResp.IdArticuloWeb;
				this.objGarantia.NombreCuenta = ObjResp.cliente.Nombre;
				this.objGarantia.Folio = ObjResp.FolioPedido;
				this.objGarantia.Producto = ObjResp.Articulo;
				this.objGarantia.Material = ObjResp.Material;
				this.objGarantia.Proteccion = ObjResp.Proteccion;
				this.objGarantia.Recubrimiento = ObjResp.Recubrimiento;
                this.objGarantia.FechaSalida = ObjResp.Fecha;
				this.objGarantia.FechaSolicitud = ObjResp.Fecha;

				this.Medidas.RxOD.ESF = ObjResp.OdEsfera;
				this.Medidas.RxOD.CIL = ObjResp.OdCilindro;
				this.Medidas.RxOD.EJE = ObjResp.OdEje;
				this.Medidas.RxOD.ADD = ObjResp.OiAdicion;
				this.Medidas.RxOD.DNP = ObjResp.OdDnp;
				this.Medidas.RxOD.ALT = ObjResp.OdAltMon;

				this.Medidas.RxOI.ESF = ObjResp.OiEsfera;
				this.Medidas.RxOI.CIL = ObjResp.OiCilindro;
				this.Medidas.RxOI.EJE = ObjResp.OiEje;
				this.Medidas.RxOI.ADD = ObjResp.OiAdicion;
				this.Medidas.RxOI.DNP = ObjResp.OiDnp;
				this.Medidas.RxOI.ALT = ObjResp.OiAltMon;

				
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
				this.GarantiasPermitidas();
            });
        },
		Recuperar()
        {
            this.$http.get(
                "garantias/"+this.objGarantia.IdGarantiaS
            ).then((res) => {
                this.objGarantia = res.data.data;
				this.Medidas = JSON.parse(this.objGarantia.MedidasRx);
				this.RutaImagen = res.data.rutaFile;

				// en caso de que necesite fecha
				// let formatedDate1 = this.objGarantia.FechaSalida.replace(/-/g,'\/');
                // this.objGarantia.FechaSalida = new Date(formatedDate1);

				// let formatedDate2 = this.objGarantia.Fecha.replace(/-/g,'\/');
                // this.objGarantia.Fecha = new Date(formatedDate2);
				
				// let formatedDate3 = this.objGarantia.FechaSolicitud.replace(/-/g,'\/');
                // this.objGarantia.FechaSolicitud = new Date(formatedDate3);
            }).finally(()=>{
                this.ConfigLoad.ShowLoader = false;
            });
        },
        Limpiar()
        {
            this.objGarantia = {
				IdGarantiaS: 0,
				IdPedido: 0,
				IdArticuloWeb: 0,
				FechaSalida: '',
				Fecha: moment(new Date()).format('YYYY-MM-DD'),
				NombreCuenta: '',
				Folio: '',
				Producto: '',
				Material: '',
				Proteccion: '',
				Recubrimiento: '',
				MedidasRx: '',
				TipoGarantia: '',
				RespuestaTipoGarantia: '',
				FechaSolicitud: '',
				MotivoSolicitado: '',
				MotivoMigracion: '',
				ImagenLente: '',
				IdUserSolicita: 0,
				IdUserAutoriza: 0,
				EstatusGarantia: '',
				EstatusAutorizacion: '',
				ErrorEnOD: '',
				ErrorEnOI: '',
            }
            this.errorvalidacion = [];
        },
		LimpiaTipoGarantia()
		{
			if(this.objGarantia.TipoGarantia != 'Crizal'){
				this.objGarantia.RespuestaTipoGarantia = '';
			}
		},
		ShowForm()
		{
			this.TipoVista = 2;
			if(this.objGarantia.IdPedido > 0){
				this.RecuperaPedido();
			}
			this.poBtnSave.ShowBtnSave = true;
			//https://mdbootstrap.com/docs/standard/extended/profiles/
		},
		GarantiasPermitidas()
		{
			this.$http.get("garantiasPorArticulosWeb",{
                params:{
                    IdArticuloWeb: this.objGarantia.IdArticuloWeb,
                    Simple: 1,
                }
            }).then((res) => {

                let response = res.data.data;
				this.TiposDeGarantias = this.ObtenerGarantiasPorArticulo(response);
                
            }).finally(()=>{
            });
		},
		ObtenerGarantiasPorArticulo(ArrABuscar)
		{
			let ArrOriginal = Calendar.TiposDeGarantia;
			let Seleccionados = [];

			ArrABuscar.forEach((elemento,index) => {
				const NewArray = ArrOriginal.filter(function(Item){
					if(Item.TipoGarantia == elemento.TipoGarantia){
						return Item;
					}else{
						return '';
					}
				});

				if(NewArray[0])
				{
					Seleccionados.push(NewArray[0]);
				}
			});

			return Seleccionados;
		}
    },
    created() {
		this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(obj)=>
        {
			this.poBtnSave.ShowBtnSave = false;
			this.RecuperaRutasNormas();
			
			let Id = obj.IdGarantia;
            this.ConfigLoad.ShowLoader = true;    
            this.poBtnSave.DisableBtn = false;

            this.bus.$off('Save_'+this.Emit);
            this.bus.$on('Save_'+this.Emit,()=>
            {
                this.Guardar();
            });
            this.Limpiar();

			this.objGarantia.IdPedido = obj.ObjPedido.IdPedido;

			if(obj.TipoVista == 1)
			{
				this.ConfigLoad.ShowLoader = false;
			}
			else
			{
				if(this.objGarantia.IdPedido > 0){
					// this.RecuperaPedido();
					this.ShowForm();
				}
				if (Id!='') 
				{
					this.objGarantia.IdGarantiaS = Id;
					this.Recuperar();
				}
				else
				{
					this.ConfigLoad.ShowLoader = false;
				}
			}
        });
    }
}
</script>
